<div class="anomaly-column-container">
  <span *ngIf="isSeverity">
    <icon-component
      [cssClass]="['severity-indicator', severityIndicatorClass]"
      [iconName]="'record-filled'"
    ></icon-component>
  </span>
  <span>{{ columnContent }}</span>
</div>
